import React from "react";
import PropTypes from "prop-types";
import { Whisper, Tooltip } from "rsuite";

/**
 * Wrapper component that adds tooltip functionality to collapsed nav items
 */
const NavTooltipWrapper = ({ collapsed = false, label, children }) => {
  if (!collapsed) {
    return children;
  }

  return (
    <Whisper
      placement="right"
      trigger="hover"
      speaker={<Tooltip className="sidenav-tooltip">{label}</Tooltip>}
    >
      <div className="sidenav__item-inner">{children}</div>
    </Whisper>
  );
};

NavTooltipWrapper.propTypes = {
  collapsed: PropTypes.bool,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default NavTooltipWrapper;
